export default "__VITE_ASSET__vwcZTbGO__"